<template>
    <b-row>        
        <b-col cols="12" md="12">
            <VentasComponent :lista_id="lista_id" :fecha_inicio="fecha_inicio" :fecha_fin="fecha_fin" titulo="Ventas" id="ventas"></VentasComponent>
        </b-col>
        <b-col cols="12" md="12">
            <VentasComponent :lista_id="lista_id" :fecha_inicio="fecha_inicio" :fecha_fin="fecha_fin" titulo="Devoluciones" id="devoluciones"></VentasComponent>
        </b-col>
        <b-col cols="12" md="12">
            <ProcedenciaComponent :lista_id="lista_id"/>
        </b-col>
        <b-col cols="12" md="12">
            <EnviosPostales :lista_id="lista_id" :fecha_inicio="fecha_inicio" :fecha_fin="fecha_fin"/>
        </b-col>
        <b-col cols="12" md="12">
            <OcupacionComponent :lista_id="lista_id"/>
        </b-col>
        <b-col cols="12" md="12">
            <DesgloseTiposComponent :lista_id="lista_id" :fecha_inicio="fecha_inicio" :fecha_fin="fecha_fin" id="desglose-tipo"></DesgloseTiposComponent>
        </b-col>
        <b-col cols="12" md="12">
            <DesgloseMetodosPagoComponent :lista_id="lista_id" :fecha_inicio="fecha_inicio" :fecha_fin="fecha_fin" id="desglose-metodos-pago"></DesgloseMetodosPagoComponent>
        </b-col>
        <b-col cols="12" md="12">
            <CuponesDescuentoComponent :lista_id="lista_id" :fecha_inicio="fecha_inicio" :fecha_fin="fecha_fin" id="cupones-descuento"></CuponesDescuentoComponent>
        </b-col>
    </b-row>
</template>

<script>
import DesgloseTiposComponent from '@/components/backend/estadisticas/abonos/DesgloseTiposComponent';
import VentasComponent from '@/components/backend/estadisticas/abonos/VentasComponent';
import ProcedenciaComponent from "@/components/backend/estadisticas/abonos/ProcedenciaComponent";
import EnviosPostales from "@/components/backend/estadisticas/abonos/EnviosPostales";
import OcupacionComponent from "@/components/backend/estadisticas/abonos/ocupacion/OcupacionComponent";
import CuponesDescuentoComponent from '@/components/backend/estadisticas/abonos/CuponesDescuentoComponent';
import DesgloseMetodosPagoComponent from '@/components/backend/estadisticas/abonos/DesgloseMetodosPagoComponent';

export default {
    props: ['lista_id', 'fecha_inicio', 'fecha_fin'],
    components: {
        ProcedenciaComponent, VentasComponent, DesgloseTiposComponent, EnviosPostales, OcupacionComponent, CuponesDescuentoComponent, DesgloseMetodosPagoComponent
    }
}
</script>